import type { ContentItem } from "@/types/content";

export const movies: ContentItem[] = [
  {
    id: "mv-01",
    category: "movie-recommend",
    title: "星际回响",
    summary:
      "近未来太空探索题材科幻片，以宏大视觉与细腻情感并重的叙事，探讨人类与故乡之间的关系。",
    cover:
      "https://readdy.ai/api/search-image?query=minimal%20sci-fi%20movie%20poster%20with%20a%20lone%20astronaut%20facing%20a%20glowing%20red%20nebula%2C%20clean%20vertical%20composition%2C%20cinematic&width=600&height=880&seq=mv01-poster&orientation=portrait",
    author: "红桃网影评组",
    date: "2026-10-09",
    year: "2026",
    genre: "科幻 / 冒险",
    region: "中国",
    heat: 95,
    content:
      "<p>《星际回响》是一部近未来太空探索题材的科幻电影。影片以一支深空探索舰队的远航为主线，在宏大的宇宙场景中嵌入对人性与情感的思考。</p><h3>看点</h3><p>影片最大的亮点在于视觉呈现。全片采用 IMAX 摄影机拍摄，实景舱段与视效合成结合，让太空场景既有真实质感又不失瑰丽想象。</p><p>叙事层面，影片没有一味追求宏大，而是把镜头对准人物关系，让硬核科幻有了温度。</p><h3>适合谁看</h3><p>如果你是科幻片爱好者，又偏爱有情感厚度的故事，这部影片值得放进观影清单。</p>",
  },
  {
    id: "mv-02",
    category: "movie-recommend",
    title: "漫长的晴天",
    summary:
      "文艺生活流电影，聚焦普通家庭四季流转中的日常片段，用克制镜头讲述陪伴与告别。",
    cover:
      "https://readdy.ai/api/search-image?query=minimal%20arthouse%20movie%20poster%20with%20a%20quiet%20sunlit%20window%20and%20a%20single%20chair%2C%20warm%20dusty%20tone%2C%20clean%20vertical%20layout&width=600&height=880&seq=mv02-poster&orientation=portrait",
    author: "红桃网影评组",
    date: "2026-10-01",
    year: "2026",
    genre: "剧情 / 家庭",
    region: "中国",
    heat: 82,
    content:
      "<p>《漫长的晴天》以生活流的方式讲述一个普通家庭在四季中的日常。影片节奏舒缓，细节丰富，用大量留白把情感交给观众体会。</p><h3>看点</h3><p>影片的表演自然克制，画面光影处理细腻，很多场景看似平常，却在细节中藏着情绪的重量。</p><p>对于偏爱慢节奏与真实感的观众，这是一部需要静下心来看的作品。</p><h3>适合谁看</h3><p>喜欢文艺片、喜欢在平淡中感受力量的观众会格外喜欢它。</p>",
  },
  {
    id: "mv-03",
    category: "movie-recommend",
    title: "雾中来信",
    summary:
      "悬疑推理电影，由一封来历不明的信件展开，层层揭开信任与谎言交织的往事。",
    cover:
      "https://readdy.ai/api/search-image?query=suspense%20thriller%20movie%20poster%20with%20foggy%20silhouette%20and%20a%20single%20red%20seal%2C%20dark%20moody%20tone%2C%20clean%20vertical%20composition&width=600&height=880&seq=mv03-poster&orientation=portrait",
    author: "红桃网影评组",
    date: "2026-10-05",
    year: "2026",
    genre: "悬疑 / 犯罪",
    region: "中国",
    heat: 88,
    content:
      "<p>《雾中来信》由一封来历不明的信件切入，通过多线叙事层层推进，把看似无关的人物串联成一桩旧案。</p><h3>看点</h3><p>影片气氛营造出色，灰冷的色调与雾气的运用强化了悬念感。剧本伏笔密集，适合喜欢推理的观众反复品味。</p><p>同时，影片并不满足于解谜，而是借案件探讨了信任与谎言的边界。</p><h3>适合谁看</h3><p>钟爱悬疑推理与人性题材的观众不容错过。</p>",
  },
  {
    id: "mv-04",
    category: "movie-recommend",
    title: "山河故梦",
    summary:
      "古装史诗电影，以乱世中的人物命运为线索，展现一幅壮阔而苍凉的山河画卷。",
    cover:
      "https://readdy.ai/api/search-image?query=epic%20chinese%20historical%20movie%20poster%20with%20ancient%20palace%20silhouette%20and%20red%20sun%2C%20elegant%20oriental%20tone%2C%20vertical%20layout&width=600&height=880&seq=mv04-poster&orientation=portrait",
    author: "红桃网影评组",
    date: "2026-10-07",
    year: "2026",
    genre: "历史 / 剧情",
    region: "中国",
    heat: 90,
    content:
      "<p>《山河故梦》是一部古装史诗电影，故事以乱世为背景，通过几个人物的命运浮沉，勾勒出一个时代的轮廓。</p><h3>看点</h3><p>影片在美术与服化道上极为考究，实景搭建的城池与宫殿极具代入感。东方美学的呈现是影片的一大卖点。</p><p>叙事上，影片试图在宏大与细腻之间找到平衡，让历史有了人的温度。</p><h3>适合谁看</h3><p>偏爱历史题材与精美画面的观众会很有收获。</p>",
  },
  {
    id: "mv-05",
    category: "movie-recommend",
    title: "极限航线",
    summary:
      "动作电影，以一桩跨城案件为线索，用大量实拍特技带来紧张的追凶旅程。",
    cover:
      "https://readdy.ai/api/search-image?query=action%20movie%20poster%20with%20a%20motorcycle%20leaning%20into%20a%20turn%20on%20a%20coastal%20road%2C%20dynamic%20angle%2C%20warm%20red%20orange%20tone%2C%20vertical&width=600&height=880&seq=mv05-poster&orientation=portrait",
    author: "红桃网影评组",
    date: "2026-09-26",
    year: "2026",
    genre: "动作 / 冒险",
    region: "中国",
    heat: 78,
    content:
      "<p>《极限航线》是一部主打真实感的动作电影，围绕一桩跨城案件展开紧张的追凶旅程。</p><h3>看点</h3><p>影片坚持实拍特技，追车、爆破与近身格斗场面都颇具冲击力，节奏紧凑、爽感十足。</p><p>在动作之外，影片也刻画了主角的动机与抉择，让人物不至于单薄。</p><h3>适合谁看</h3><p>喜欢硬核动作场面的观众会看得很过瘾。</p>",
  },
  {
    id: "mv-06",
    category: "movie-recommend",
    title: "云端小镇",
    summary:
      "合拍动画电影，讲述少年在漂浮云端的小镇上展开的奇幻冒险与成长故事。",
    cover:
      "https://readdy.ai/api/search-image?query=animated%20fantasy%20movie%20poster%20of%20a%20whimsical%20floating%20town%20on%20clouds%20at%20sunset%2C%20colorful%20and%20warm%2C%20vertical%20layout&width=600&height=880&seq=mv06-poster&orientation=portrait",
    author: "红桃网影评组",
    date: "2026-09-28",
    year: "2026",
    genre: "动画 / 奇幻",
    region: "中国 / 海外合拍",
    heat: 76,
    content:
      "<p>《云端小镇》构建了一个漂浮在云端的奇幻世界，故事围绕少年的一次成长冒险展开。</p><h3>看点</h3><p>影片视觉明亮活泼，暖橘与珊瑚色的运用让画面充满治愈感。冒险主线之外，关于友情与勇气的主题表达温暖动人。</p><p>适合全家一起观看，也很适合喜欢奇幻世界观的观众。</p>",
  },
  {
    id: "mv-07",
    category: "movie-recommend",
    title: "时光信箱",
    summary:
      "温情治愈电影，以一家老信箱为纽带，串联起几段跨越时间的温暖故事。",
    cover:
      "https://readdy.ai/api/search-image?query=warm%20nostalgic%20movie%20poster%20with%20a%20vintage%20wooden%20mailbox%20and%20autumn%20leaves%2C%20gentle%20golden%20light%2C%20vertical%20layout&width=600&height=880&seq=mv07-poster&orientation=portrait",
    author: "红桃网影评组",
    date: "2026-09-24",
    year: "2026",
    genre: "剧情 / 治愈",
    region: "中国",
    heat: 70,
    content:
      "<p>《时光信箱》以一家老信箱为纽带，讲述几段跨越时间的温暖故事，主题围绕遗憾与和解展开。</p><h3>看点</h3><p>影片情感真挚，节奏平缓，用一个个小故事拼出生活的温度。对于想找一部安安静静看完的电影的观众来说，再合适不过。</p>",
  },
  {
    id: "mv-08",
    category: "movie-recommend",
    title: "夜航西飞",
    summary:
      "剧情电影，讲述一位年轻飞行员在长途航线上经历的自我寻找与和解之旅。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20movie%20poster%20of%20an%20airplane%20wing%20over%20a%20sea%20of%20clouds%20at%20dawn%2C%20warm%20amber%20sky%2C%20clean%20vertical%20layout&width=600&height=880&seq=mv08-poster&orientation=portrait",
    author: "红桃网影评组",
    date: "2026-09-22",
    year: "2026",
    genre: "剧情 / 冒险",
    region: "中国",
    heat: 68,
    content:
      "<p>《夜航西飞》讲述一位年轻飞行员在长途航线上经历的自我寻找之旅。影片以飞行作为载体，探讨了孤独、勇气与和解。</p><h3>看点</h3><p>画面辽阔，天空与云层的呈现极具美感。人物内心的刻画细腻，情绪推进自然。</p>",
  },
  {
    id: "mv-09",
    category: "movie-recommend",
    title: "山海之间",
    summary:
      "现实主义题材电影，聚焦小城青年在时代变迁中的选择与坚持，质朴而有力。",
    cover:
      "https://readdy.ai/api/search-image?query=realistic%20movie%20poster%20of%20mountains%20and%20sea%20meeting%20at%20dusk%20with%20a%20small%20town%20silhouette%2C%20muted%20warm%20tone%2C%20vertical%20layout&width=600&height=880&seq=mv09-poster&orientation=portrait",
    author: "红桃网影评组",
    date: "2026-09-20",
    year: "2025",
    genre: "剧情 / 现实",
    region: "中国",
    heat: 65,
    content:
      "<p>《山海之间》是一部现实主义题材电影，聚焦小城青年在时代变迁中的选择与坚持。</p><h3>看点</h3><p>影片语言质朴，表演扎实，把普通人的困境与韧劲拍得真实可信。故事虽不宏大，却有直抵人心的力量。</p>",
  },
];